import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowSquareOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M14.1 1v1.8h5.827l-8.463 8.464 1.272 1.272L21.2 4.073V9.9H23V1z" fill="currentColor" />
            <path
                d="M1 13C1 4.966 2.054 3.255 9 3.03V4.83c-1.19.04-2.144.125-2.92.271-1.154.218-1.737.54-2.088.89-.351.352-.674.935-.891 2.089C2.88 9.25 2.8 10.827 2.8 13s.08 3.75.3 4.921c.218 1.154.54 1.737.892 2.088.35.35.934.673 2.087.89 1.172.221 2.747.301 4.921.301s3.75-.08 4.92-.3c1.155-.218 1.737-.54 2.089-.891.35-.351.673-.934.89-2.088.146-.777.231-1.732.271-2.92h1.801c-.226 6.946-1.937 8-9.971 8-8.75 0-10-1.25-10-10"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowSquareOutlinedSize24Glyph.displayName = 'ArrowSquareOutlinedSize24Glyph';
